//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Drawer } from "ant-design-vue";
import "ant-design-vue/es/drawer/style/index.css"
// import VistatLogoAnimated from "@/components/base/VistatLogoAnimated.vue";

export default {
  name: "HeaderMenuDrawer",
  components: {
    'a-drawer': Drawer,
    // VistatLogoAnimated,
  },
  props: {
    icon: {
      type: String,
      default: null
    },
    buttonLabel: {
      type: String,
      default: 'Открыть'
    }
  },
  data() {
    return {
      visible: false,
    };
  },
  watch: {
    $route() {
      this.closeDrawer();
    }
  },
  methods: {
    showDrawer() {
      this.visible = true;
    },
    closeDrawer() {
      this.visible = false;
    },
  },
};
